module.exports = __webpack_public_path__ + "img/ina-ph.707bbf1c.png";